import React from 'react';
import { ExceptionServiceState } from '../../../types/zitoneoServicesTypes';
import TextInput from '../../../../../muiComponents/TextInput/TextInput';
import DateInput from '../../../../../muiComponents/DateInput';
import Grid from '../../../../../muiComponents/Grid';
import GridChild from '../../../../../muiComponents/GridChild';
import {
    doubleMD_ColumnGrid,
    full_ColumnGrid,
    gridSpacing30,
} from '../../../../../utils/commonVariables/grid';
import { useZitoneoServices } from '../../../contexts/ZitoneoContentContext';
import SwitchInput from '../../../../../muiComponents/switchInput/SwitchInput';
import useTranslate from '../../../../../customHooks/useTranslate';
import Icon from '../../../../../muiComponents/Icon';
import IconButton from '../../../../../muiComponents/IconButton';
import CheckboxInput from '../../../../../muiComponents/CheckboxInput';

interface ServiceExceptionProps {
    idHotelService: string;
    exception: ExceptionServiceState;
    isDisabled: boolean;
}

const ServiceException = (props: ServiceExceptionProps) => {
    const { idHotelService, exception, isDisabled } = props;
    const translate = useTranslate();

    const {
        editExceptionInService,
        handleDeleteException,
        handleEditExceptionDescription,
        criticalExceptionLevelType,
    } = useZitoneoServices();
    return (
        <aside className='service-exception__container'>
            <header className='flex flex-align-baseline gap-10 flex-between'>
                <div className='flex flex-align-center gap-10'>
                    <Icon
                        iconName='ErrorOutlineOutlined'
                        className='service-exception__header-icon'
                    />
                    <h3 className='service-exception__header-text'>{`${translate(
                        'errata'
                    )} · ${translate('temporary_change')}`}</h3>{' '}
                </div>{' '}
                <div className='flex flex-align-center gap-10'>
                    <CheckboxInput
                        labelText={'critical'}
                        checked={
                            exception.IdServiceExceptionLevelType ===
                            parseInt(criticalExceptionLevelType?.Id || '0')
                        }
                        disabled={isDisabled}
                        onChange={(e: { target: { checked: boolean } }) => {
                            editExceptionInService(idHotelService, {
                                ...exception,
                                IdServiceExceptionLevelType: e.target.checked
                                    ? parseInt(
                                          criticalExceptionLevelType?.Id || '0'
                                      )
                                    : 0,
                            });
                        }}
                    />

                    <SwitchInput
                        labelText='Active'
                        checked={exception.Active}
                        disabled={isDisabled}
                        onChangeMethod={(e: { target: { checked: boolean } }) =>
                            editExceptionInService(idHotelService, {
                                ...exception,
                                Active: e.target.checked,
                            })
                        }
                    />
                    <IconButton
                        iconName='Close'
                        disabled={isDisabled}
                        onClick={() =>
                            handleDeleteException(idHotelService, exception.Id)
                        }
                    />
                </div>
            </header>
            <Grid columnSpacing={gridSpacing30} rowSpacing={gridSpacing30}>
                <GridChild gridProps={full_ColumnGrid}>
                    <TextInput
                        labelText='Description'
                        value={exception.Description || ''}
                        multiline
                        rows={3}
                        disabled={isDisabled}
                        handleChange={(_e: unknown, newValue: string) =>
                            handleEditExceptionDescription(
                                idHotelService,
                                exception.Id,
                                newValue
                            )
                        }
                    />
                </GridChild>
                {exception.Dates?.map(date => [
                    <GridChild
                        key={`${date.Id}-from`}
                        gridProps={doubleMD_ColumnGrid}
                    >
                        <DateInput
                            label={`From`}
                            value={date.FromDate}
                            disabled={isDisabled}
                            onChange={(value: string) =>
                                editExceptionInService(idHotelService, {
                                    ...exception,
                                    Dates: exception.Dates.map(d =>
                                        d.Id === date.Id
                                            ? {
                                                  ...d,
                                                  FromDate: value
                                                      ? new Date(value)
                                                      : '',
                                                  __isChanged: true,
                                              }
                                            : d
                                    ),
                                })
                            }
                            maxDate={date.ToDate || undefined}
                        />
                    </GridChild>,
                    <GridChild
                        key={`${date.Id}-to`}
                        gridProps={doubleMD_ColumnGrid}
                    >
                        <DateInput
                            label={`To`}
                            value={date.ToDate}
                            disabled={isDisabled}
                            onChange={(value: string) =>
                                editExceptionInService(idHotelService, {
                                    ...exception,
                                    Dates: exception.Dates.map(d =>
                                        d.Id === date.Id
                                            ? {
                                                  ...d,
                                                  ToDate: value
                                                      ? new Date(value)
                                                      : '',
                                                  __isChanged: true,
                                              }
                                            : d
                                    ),
                                })
                            }
                            minDate={date.FromDate || undefined}
                        />
                    </GridChild>,
                ])}
            </Grid>
        </aside>
    );
};

export default ServiceException;
